export default {"src":"/polygon/_next/static/media/aave.ce9bab5d.svg","height":48,"width":48};